import styled from 'styled-components';

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;

  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`;
